module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"header":"MAP DIRECTORY"},"es":{"header":"Directorio Mapas"}}')
  delete Component.options._Ctor
}
